<modal-hl></modal-hl>
<toaster-by-subject></toaster-by-subject>
<div class="application">
  <div class="application__header" *ngIf="isAuthenticationPathResolved">
    <cp-header></cp-header>
  </div>
  <div class="application__content">
    <router-outlet></router-outlet>
  </div>
  <div class="application__footer">
    <cp-footer></cp-footer>
  </div>
</div>
